import { Box, Typography, ButtonBase } from "@mui/material";
import moment from "moment";
import React from "react";

const timeFormat = (date, userTimeFormat) => {
  return moment(date, userTimeFormat).format(userTimeFormat);
};

const RenderTimeSlots = ({
  selectedSessionTime,
  time,
  handleSelectedTime,
  userTimeFormat,
  customStyle,
}) => {
  return (
    <ButtonBase
      data-testid="public-booking-time-slot"
      sx={(themes) => ({
        width: "100%",
        border: "1px solid #D6D6D6",
        borderRadius: "10px",
        height: "42px",
        backgroundColor: "#FFFFFF",
        color: `${customStyle?.accentColor ?? "#000"} !important`,
        ...(selectedSessionTime?.start === time.start && {
          backgroundColor: `${
            customStyle?.accentColor ?? "var(--bg-black)"
          } !important`,
          border: "1px solid",
          color: `${customStyle?.buttonTextColor ?? "#FFF"} !important`,
          borderColor: `${
            customStyle?.accentColor ?? "var(--bg-black)"
          } !important`,
        }),
        "&:hover": {
          backgroundColor: `${
            customStyle?.accentColor ?? "var(--bg-black)"
          } !important`,
          border: "1px solid",
          borderColor: `${
            customStyle?.accentColor ?? "var(--bg-black)"
          } !important`,
          color: `${customStyle?.buttonTextColor ?? "#FFF"} !important`,
        },
      })}
      onClick={() => handleSelectedTime(time)}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: "18px",
            textAlign: "center",
            letterSpacing: "0.03em",
            color:
              selectedSessionTime?.start === time.start
                ? `${customStyle?.buttonTextColor ?? "#FFF"} !important`
                : "inherit",
            fontFamily: `var(--font-${customStyle?.bodyFont})`,
          }}
        >
          {timeFormat(new Date(time.start), userTimeFormat)}
        </Typography>
      </Box>
    </ButtonBase>
  );
};

export default RenderTimeSlots;
